<div [showHideAnimation]="page">
  @if (title) {
    <h3>{{ title }}</h3>
  }
  <gstar-template-factory />
</div>
